import { getInstance } from '../index';
import { apiBaseUrl } from '../../utilities/api/apiHelper';

class Decision {
  constructor() {
    this.axios = getInstance();
  }

  async postDecisionQuote(applicationId) {
    return await this.axios.post(
      `${apiBaseUrl}/actions/TriggerDecisionQuote/${applicationId}`,
      {}
    );
  }

  async getApplicantDecisionQuote(applicantId, optOutOflogging) {
    return await this.axios.post(
      `${apiBaseUrl}/decision/${applicantId}/quote${
        optOutOflogging ? '/optoutoflogging' : ''
      }`
    );
  }

  async getApplicantQiDecisionQuote(applicantId) {
    return await this.axios.post(
      `${apiBaseUrl}/decision/qi/${applicantId}/quote`
    );
  }

  async postDecisionProducts(applicantId, productTypes) {
    return await this.axios.post(
      `${apiBaseUrl}/decision/${applicantId}/product/optoutoflogging`,
      { productTypes }
    );
  }

  async postDecisionQiProducts(applicantId, productTypes) {
    return await this.axios.post(
      `${apiBaseUrl}/decision/qi/${applicantId}/product`,
      { productTypes }
    );
  }

  async postRemoveApplicantAtDecision(applicantId) {
    return await this.axios.post(
      `${apiBaseUrl}/actions/removeApplicantAtDecision/${applicantId}`,
      {}
    );
  }
}

const decision = new Decision();
export default decision;
